export default __webpack_public_path__ + "static/media/gold.737eeeee.png";